import React from 'react'
import { useSelector, useDispatch } from 'react-redux'

// import { siteMapNavItem } from '../../types/siteMap'
import { updateNav } from '../../slices/siteMapSlice'
import Button from '../library/Button'
// import { getSiteMap } from '../../utils'

const ClusterA = () => {
  const dispatch = useDispatch()
  //   const map = useSelector((state: any) => state.siteMap.map)

  const handleGuess = () => {
    // const navItem: siteMapNavItem = siteMap[map as keyof typeof siteMap][0]
    // const siteMap = getSiteMap(map)
    dispatch(updateNav(null))
  }

  return (
    <>
      <h2>ClusterA</h2>
      <Button onClick={handleGuess}>update site map</Button>
    </>
  )
}

export default ClusterA
